export default __webpack_public_path__ + "assets/icons/whole-shipping.72678556.svg";